// extracted by mini-css-extract-plugin
export default {"popup-back":"Popup_popup-back__tKZhI","toggled":"Popup_toggled__02Y3D"};